// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1zFq2","inner":"Form_inner__2NZN2","range":"Form_range__37xX_","name":"Form_name__2h1Lw","actions":"Form_actions__1fzYx"};